export default __webpack_public_path__ + "static/media/lexx-logo.7b54217e.png";